<template>
  <vs-row>
    <vs-row class="catBgClr mx-4">
      <vs-row>
        <h3 class="p-5 pb-4">Add Point Groups</h3>
      </vs-row>
      <p class="pl-5 pb-6 pt-0 mb-2 whiteText">
        You may drag the fields to change the order
      </p>

      <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

      <vs-row class="">
        <vs-col vs-lg="6" vs-sm="6" class="">
          <vs-row>
            <vs-col vs-lg="12">
              <div class="my-2 ml-5">Category {{ point_categories.order }}</div>
              <vs-input
                id="transparent"
                v-model="point_categories.name"
                class="w-full p-3 ml-2"
                :disabled="true"
              />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col
          vs-lg="2"
          vs-sm="3"
          vs-type="flex"
          vs-justify="flex-start"
          class="ml-5"
        >
          <div
            v-if="
              point_categories.isDeleteable ||
              point_categories.isDeleteable == undefined
            "
            class="flex flex-wrap-reverse items-center cursor mt-4 pt-0 ml-1"
            @click="removeMainCategory(point_categories._id)"
          >
            <MinusSquareIcon color="#707070" class="mt-5 ml-2" />
            <div class="addCardFont font-semibold ml-3 cursor mt-4">Remove</div>
          </div>

          <div
            v-if="point_categories.isDeleteable == false"
            class="cursor mt-4 pt-0 ml-1"
            style="opacity: 0.3"
          >
            <vx-tooltip
              text="This category cannot be deleted since it is in use by cards"
              position="top"
            >
              <vs-row>
                <MinusSquareIcon color="white" class="mt-5" />
                <div
                  class="addCardFont font-semibold ml-3 cursor mt-5 pb-1 whiteText"
                >
                  Remove
                </div>
              </vs-row>
            </vx-tooltip>
          </div>
        </vs-col>
      </vs-row>

      <vs-row>
        <div
          class="flex flex-wrap-reverse items-center ml-5 cursor mt-4 mb-3 pt-0"
          @click="addNewCategory"
        >
          <PlusSquareIcon color="white" />
          <h6 class="ml-2 mt-1 cursor">Add Subcategory</h6>
        </div>
      </vs-row>
      <!--vs-row v-if="errors.categories.success">
      <p class="p-5 py-3 dangerColor">{{ errors.categories.msg }}</p>
    </vs-row-->

      <draggable
        v-model="point_Subcategories"
        v-bind="dragOptions"
        class="w-full"
      >
        <transition-group type="transition" name="flip-list">
          <vs-row
            :key="index"
            v-for="(category, index) in point_Subcategories"
            class="ml-5"
          >
            <vs-col vs-lg="6" vs-sm="6" class="pr-6" id="inputBorder">
              <vs-row>
                <vs-col class="mt-6 pt-1" vs-lg="1">
                  <MenuIcon class="mt-6" />
                </vs-col>
                <vs-col vs-lg="11">
                  <div class="my-2 pt-1 ml-1">Subcategory {{ index + 1 }}</div>

                  <!--vs-input
                    v-model="point_Subcategories[index].name"
                    class="w-full pr-15 pl-3 pt-3 pb-3 ml-1"
                    :disabled="point_Subcategories.length == 0"
                  /-->
                  <select
                    v-if="point_categoriesList.length >= 0"
                    v-model="point_Subcategories[index].name"
                    :class="{
                      'w-full posSelect  pl-3': true,
                    }"
                    @change="handleSelect(index)"
                  >
                    <option selected>
                      {{ point_Subcategories[index].name }}
                    </option>
                    <option
                      v-for="categor in point_categoriesList"
                      :key="categor._id"
                      :value="categor._id"
                    >
                      {{ categor.name }}
                    </option>
                  </select>
                </vs-col>
              </vs-row>
            </vs-col>
            <vs-col vs-lg="3" vs-sm="3" vs-type="flex" vs-justify="flex-start">
              <div
                v-if="
                  point_Subcategories[index].isDeleteable ||
                  point_Subcategories[index].isDeleteable == undefined
                "
                class="flex flex-wrap-reverse items-center cursor mt-5 pl-4"
                @click="removeCategory(index)"
              >
                <MinusSquareIcon color="white" class="mt-5" />
                <div class="addCardFont font-semibold ml-3 cursor mt-6">
                  Remove
                </div>
              </div>

              <div
                v-if="point_Subcategories[index].isDeleteable == false"
                class="cursor mt-5 pt-0 ml-1"
                style="opacity: 0.3"
              >
                <vx-tooltip
                  text="This category cannot be deleted since it is in use by cards"
                  position="top"
                >
                  <vs-row>
                    <MinusSquareIcon color="white" class="mt-5" />
                    <div class="addCardFont font-semibold ml-3 cursor mt-6">
                      Remove
                    </div>
                  </vs-row>
                </vx-tooltip>
              </div>
            </vs-col>
          </vs-row>
        </transition-group>
      </draggable>
      <vs-row v-if="errors.categories.success">
        <vs-col vs-lg="6" vs-sm="12" vs-type="flex" vs-justify="flex-start">
          <p class="text pt-5 pb-5 py-3 dangerColor">
            {{ errors.categories.msg }}
          </p>
        </vs-col>
      </vs-row>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="updateStatus.status"
      >
        <div style="magine-bottom: 30px" class="mb-5">
          <h5>{{ updateStatus.msg }}</h5>
        </div>
        <div
          style="text-align: center; margin-top: 30px"
          vs-type="flex"
          vs-justify="center"
        >
          <vs-button
            class="mt-11"
            @click="topointgroups()"
            color="primary"
            type="filled"
            >Show Point Groups</vs-button
          >
        </div>
      </vs-popup>
      <vs-popup
        class="holamundo"
        title="Status"
        :active.sync="NoCategory.status"
        @close="closefunc()"
      >
        <h5>{{ NoCategory.msg }}</h5>
      </vs-popup>
    </vs-row>
    <vs-row class="mt-2 pr-10 pl-1" vs-justify="flex-end">
      <vs-button @click="updateCategories">Save</vs-button>
    </vs-row>
  </vs-row>
</template>

<script>
import { PlusSquareIcon, MinusSquareIcon, MenuIcon } from "vue-feather-icons";
import draggable from "vuedraggable";
import { genericErrorMessage, toast } from "@/keys/toast-messages";

export default {
  components: {
    PlusSquareIcon,
    MinusSquareIcon,
    MenuIcon,
    draggable,
  },

  data() {
    return {
      point_categories: "",
      remove_categories: [],
      point_Subcategories: [],
      point_categoriesList: [],

      errors: {
        categories: {
          msg: "",
          success: false,
        },

        duplicateIndices: [],
      },

      updateStatus: {
        msg: "",
        status: false,
      },
      NoCategory: {
        msg: "",
        status: false,
      },
      genericErrorMessage,
      toast,
    };
  },
  methods: {
    closeupdate() {
      this.updateStatus = {
        status: false,
        msg: "",
      };
    },
    async topointgroups() {
      await this.closeupdate();
      this.$router.push({
        name: "point-categories",
        params: { edit: true },
      });
    },
    closefunc() {
      console.log("closed", this.NoCategory.status);
      if (this.NoCategory.status == true) {
        this.NoCategory.status = false;
      } else {
        this.updateStatus = {
          status: false,
          msg: "",
        };
        // this.$router.push({
        //   name: "point-categories",
        //   params: { edit: true },
        // });
        this.$router.go(1);
      }
    },
    async removeMainCategory(inp) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .post(
              this.$ApiKeys.BASE_URL + this.$EndPoints.UpdateCategories,
              {
                remove_categories: [inp],
                isAdded: false,
              },
              {
                headers: {
                  Authorization: this.$localStorage.get("token"),
                },
              }
            )
            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                this.updateStatus = {
                  msg: res.data.data,
                  status: true,
                };
                this.$router.push({
                  name: "point-categories",
                  params: { edit: true },
                });
                //resolve(this.getCategories());
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.data.errors.categories) {
                this.errors.categories = {
                  msg: e.response.data.errors.categories,
                  success: true,
                };
              } else {
                this.errors.categories = {
                  msg: "",
                  success: false,
                };
                if (e.response.status !== 401) {
                  this.toast(this.genericErrorMessage());
                }
              }
              this.$vs.loading.close();
              // console.log("Error in updateCategories: ",e);
            });
        });
      }, 500);
    },
    async removeCategory(index) {
      if (this.point_Subcategories[index]._id) {
        await this.point_categoriesList.push(this.point_Subcategories[index]);

        await this.remove_categories.splice(
          this.remove_categories.findIndex(
            (a) => a._id == this.point_Subcategories[index]._id
          ),
          1
        );
      }
      this.point_Subcategories.splice(index, 1);
    },
    async addNewCategory() {
      if (await this.notempty()) {
        await this.point_Subcategories.push({ _id: "", name: "" });
        this.point_Subcategories = await this.point_Subcategories.map(
          (value, index) => {
            return {
              name: value.name,
              _id: value._id,
              order: index + 1,
              isDeleteable: value.isDeleteable,
            };
          }
        );
      }
    },
    getCategories() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetSubcategories, {
              params: {
                categoryId: this.point_categories._id,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })

            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.point_categoriesList = res.data.data));
                if (this.point_categories.subCategories) {
                  this.point_categories.subCategories.forEach((a) => {
                    a.category.forEach((b) => {
                      this.remove_categories.push(
                        this.point_categoriesList.splice(
                          this.point_categoriesList.findIndex(
                            (c) => c._id == b._id
                          ),
                          1
                        )
                      );
                    });
                  });
                  if (this.remove_categories.length > 0) {
                    let temp = [];
                    this.remove_categories = this.remove_categories.map(
                      (value, index) => {
                        value.forEach((a) => {
                          temp.push(a);
                        });
                      }
                    );
                    this.remove_categories = temp;
                  }
                } else {
                  this.point_categories.subCategories = [];
                }
              } else {
                this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 500);
    },

    getMainCategories(inp) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.$vs.loading.close();
        this.$vs.loading({
          background: "rgba(1,2,3,.2)",
        });
        return new Promise((resolve, reject) => {
          this.$axios
            .get(this.$ApiKeys.BASE_URL + this.$EndPoints.GetCategoryById, {
              params: {
                categoryId: inp,
              },
              headers: {
                Authorization: this.$localStorage.get("token"),
              },
            })

            .then(async (res) => {
              this.$vs.loading.close();
              if (res.data.success) {
                resolve((this.point_categories = res.data.data));
                this.getCategories();
                if (
                  this.point_categories.subCategories.length > 0 &&
                  this.point_categories.subCategories[0].category.length > 0
                ) {
                  this.point_categories.subCategories.forEach((v1) => {
                    v1.category.forEach((v2) => {
                      //this.point_Subcategories[inp].name = temp1.name.trim();
                      v2.name = v2.name.replace(/\s+/g, " ");
                      v2.name = v2.name.replace(/^\s+|\s+$/g, "");
                      this.point_Subcategories.push({
                        name: v2.name,
                        _id: v2._id,
                        //id: v1.id,
                        date: v1.date,
                        order: v1.order,
                      });
                    });
                  });
                }
              } else {
                //console.log("in else", res);
                if (res.data.errors.Category) {
                  this.NoCategory = {
                    status: true,
                    msg: res.data.errors.Category,
                  };
                }
                //this.toast(this.genericErrorMessage());
              }
            })
            .catch((e) => {
              if (e.response.status !== 401) {
                this.toast(this.genericErrorMessage());
              }
              this.$vs.loading.close();
            });
        });
      }, 500);
    },
    async notempty() {
      for (var i = 0; i < this.point_Subcategories.length; i++) {
        if (
          this.point_Subcategories[i].name == "" ||
          !this.point_Subcategories[i].name.trim()
        ) {
          this.errors.categories = {
            msg: "Please fill out all the subcategories fields",
            success: true,
          };
          return false;
        } else {
          this.errors.categories = {
            msg: "",
            success: false,
          };
        }
      }
      return true;
    },
    async hasUniqueNames() {
      var tmpArr = [];
      for (var i = 0; i < this.point_Subcategories.length; i++) {
        if (tmpArr.indexOf(this.point_Subcategories[i].name) < 0) {
          tmpArr.push(this.point_Subcategories[i].name);
        } else {
          // this.error.duplicateIndices.push(i);
          return false;
        }
      }
      // console.log('indices are: ',indices);
      return true;
    },
    async updateCategories() {
      this.hasUniqueNames(this.point_Subcategories);
      if (await this.notempty()) {
        if (await this.hasUniqueNames(this.point_Subcategories)) {
          this.errors.categories = {
            msg: "",
            success: false,
          };
          let newVar = await this.point_Subcategories.map((value, index) => {
            return {
              //id: value._id,
              order: index + 1,
              category: value._id,
            };
          });
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            this.$vs.loading.close();
            this.$vs.loading({
              background: "rgba(1,2,3,.2)",
            });
            return new Promise((resolve, reject) => {
              this.$axios
                .post(
                  this.$ApiKeys.BASE_URL + this.$EndPoints.UpdateSubcategories,
                  {
                    point_Subcategories: newVar,
                    categoryId: this.point_categories._id,
                  },
                  {
                    headers: {
                      Authorization: this.$localStorage.get("token"),
                    },
                  }
                )
                .then(async (res) => {
                  this.$vs.loading.close();
                  if (res.data.success) {
                    this.updateStatus = {
                      msg: res.data.data,
                      status: true,
                    };
                    //resolve(this.getCategories());
                  } else {
                    this.toast(this.genericErrorMessage());
                  }
                })
                .catch((e) => {
                  if (e.response.data.errors.categories) {
                    this.errors.categories = {
                      msg: e.response.data.errors.categories,
                      success: true,
                    };
                  } else {
                    this.errors.categories = {
                      msg: "",
                      success: false,
                    };
                    if (e.response.status !== 401) {
                      this.toast(this.genericErrorMessage());
                    }
                  }
                  this.$vs.loading.close();
                  // console.log("Error in updateCategories: ",e);
                });
            });
          }, 500);
        } else {
          this.errors.categories = {
            msg: "Point categories names must be unique.",
            success: true,
          };
        }
      }
    },
    async handleSelect(inp) {
      if (this.point_Subcategories[inp].name != "") {
        this.errors.categories = {
          msg: "",
          success: false,
        };
        const temp = this.point_Subcategories[inp]._id;

        let temp1 = this.point_categoriesList.find(
          (b) => b._id == this.point_Subcategories[inp].name
        );
        if (temp1) {
          //this.point_Subcategories[inp].name = temp1.name;
          this.point_Subcategories[inp].name = temp1.name.replace(/\s+/g, " ");
          this.point_Subcategories[inp].name = this.point_Subcategories[
            inp
          ].name.replace(/^\s+|\s+$/g, "");

          this.point_Subcategories[inp]._id = temp1._id;
        }
        if (temp != this.point_Subcategories[inp]._id) {
          let aa = this.remove_categories.find((a) => a._id == temp);
          if (aa) {
            this.point_categoriesList.push(aa);
            await this.remove_categories.splice(
              this.remove_categories.findIndex((a) => a == aa),
              1
            );
          }

          this.remove_categories.push(temp1);
          this.point_categoriesList.splice(
            this.point_categoriesList.findIndex(
              (a) => a._id == this.point_Subcategories[inp]._id
            ),
            1
          );
        }
      }
    },
  },
  created() {
    //this.getCategories();
  },
  mounted() {
    if (this.$route.params.id != undefined) {
      this.getMainCategories(this.$route.params.id);
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>

<style>
#inputBorder {
  cursor: grab;
}
#inputBorder input {
  border-color: #1c1c1e !important;
}

.whiteText {
  color: white !important;
}
.con-vs-tooltip {
  margin-top: 20px;
  margin-left: 10px;
  /* padding-top: 20px; */
  /* background: green; */
}
.catBgClr {
  background-color: #1c1c1e;
  padding: 20px;
  border-radius: 10px;
}
.cursor {
  cursor: pointer;
}

.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
}
.manageButton {
  width: 207px;
  border-radius: 10, 21, 10, 21;
  font-size: 13px;
}
.posSelect {
  background-color: rgb(52, 52, 52) !important;
}

@media only screen and (min-width: 800px) {
  .text {
    margin-left: 35px;
    padding-left: 30px;
  }
}
@media only screen and (max-width: 800px) {
  .text {
    margin-left: 20px;
    padding-left: 10px;
  }
}
.vs-con-input {
  border: none;
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: hidden;
  outline: none;
}
.feather.feather-minus-square {
  color: #cacaca !important;
}
</style>
